import { Component, input, output } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { Navigation } from '@/app/domains/admin/layout/ui/navigation';
import { MatSidenav } from '@angular/material/sidenav';
import { SOCIAL_LINKS } from '@/app/domains/admin/layout/data/social-links';

@Component({
  selector: 'admin-sidebar',
  imports: [Navigation, MatIcon],
  host: {
    class: 'flex w-full flex-auto flex-col',
  },
  template: `
    <!-- Header -->
    <div class="flex items-center justify-between border-b border-neutral-200 px-6 py-4">
      <a href="https://truckdriversus.com" class="flex items-center">
        <img
          src="/images/logo/tdusa-wordmark.png"
          class="h-5 w-auto"
          alt="Truck Drivers USA"
        />
      </a>

      <button
        type="button"
        class="-mr-2 flex size-10 cursor-pointer items-center justify-center text-neutral-900"
        aria-label="Close menu"
        (click)="sidenav()?.close()"
      >
        <mat-icon svgIcon="x" class="size-7" />
      </button>
    </div>

    <!-- Navigation -->
    <navigation class="mt-2 mb-4 flex-auto" (navItemSelected)="navItemSelected.emit()" />

    <!-- Spacer -->
    <div class="flex-auto"></div>

    <!-- Footer: social links + copyright, matching the truckdriversus.com menu -->
    <div class="flex flex-col gap-6 px-6 pt-4 pb-8">
      <ul class="flex items-center gap-6">
        @for (link of socialLinks; track link.id) {
          <li>
            <a
              class="block text-neutral-900 hover:text-primary-600"
              [href]="link.url"
              target="_blank"
              rel="noopener nofollow"
              [attr.aria-label]="link.label"
            >
              <svg class="size-6" viewBox="0 0 16 16" fill="currentColor" aria-hidden="true">
                <path [attr.d]="link.iconPath" />
              </svg>
            </a>
          </li>
        }
      </ul>

      <p class="m-0 text-base font-light text-neutral-900">
        © {{ year }} Truck Drivers USA. All rights reserved.
      </p>
    </div>

    <!-- Sidebar notification -->
    <!-- <div
      class="m-4 mb-2 rounded-lg border border-neutral-900/5 bg-neutral-900/5 p-4 dark:border-neutral-50/5 dark:bg-neutral-50/5"
    >
      <div class="font-semibold">Your trial is expiring soon!</div>
      <div class="mt-1 text-sm">
        You have 3 days left in your trial. Upgrade to pro to continue using all
        features.
      </div>
      <button
        matButton="filled"
        class="small mt-4 w-full"
      >
        Upgrade now
        <mat-icon
          svgIcon="move-right"
          iconPositionEnd
        />
      </button>
    </div> -->
  `,
})
export class AdminSidebar {
  sidenav = input<MatSidenav>();
  navItemSelected = output<void>();

  protected readonly socialLinks = SOCIAL_LINKS;
  protected readonly year = new Date().getFullYear();
}
